"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorUtils = void 0;
exports.errorUtils = {
    spawnSwitchErr(name, value) {
        return new Error(`Unexpected switch value: ${value} encountered for ${name}`);
    },
};
